import React, { useEffect, useState } from "react";
// Components
import { CommunitiesColumnModal } from "view/components/Modals/Community/CommunitiesColumnModal";
import FiltersList from "../FiltersList";
import HeaderBar from "./components/HeaderBar";
// Store Utils
import { useSelector } from "react-redux";
import { RootState } from "store";
// types
import { FiltersProps } from "./types";
import { IfetchObjects } from "store/objects/initialState";
import { filtersInitialState } from "store/filters/initialState";
import { isAnyObjectFilterApplied } from "../AppliedFilters";
import { getFiltersDataFromLocalStorage } from "utils/cacheOrRetriveFiltersDate";

export const Filters: React.FC<FiltersProps> = ({}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCloseDiv, setIsCloseDiv] = useState(false);
  const { data } = useSelector<RootState, IfetchObjects>(
    (state) => state?.allObjects
  );

  // Handlers
  const handleToggleDropdown = () => {
    setIsCloseDiv((prevState) => !prevState);
  };

  // Getting objectsFilter state from Redux store
  const { objectsFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );

  useEffect(() => {
    setIsCloseDiv((pre: any) => {
      return isAnyObjectFilterApplied(objectsFilter);
    });
  }, []);


  useEffect(() => {
    const filtersData = getFiltersDataFromLocalStorage();
    setIsCloseDiv((pre: any) => {
      if (filtersData !== undefined) {
        return isAnyObjectFilterApplied(filtersData.filters);
      } else {
        return isAnyObjectFilterApplied(objectsFilter);
      }
    });
  }, []);

  return (
    <>
      <div className="flex flex-col items-start justify-start w-full gap-2">
        <HeaderBar
          data={data}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          isCloseDiv={isCloseDiv}
          handleToggleDropdown={handleToggleDropdown}
        />
        <FiltersList isCloseDiv={isCloseDiv} />
      </div>
    </>
  );
};
